import type { HubCopy } from "../types";

export const HUB_PT_BR: HubCopy = {
  hero: {
    eyebrow: "Empresa brasileira de tecnologia",
    heading: { before: "Apps que se tornam", highlight: "conscientes" },
    lead: "Criamos apps para o seu dia a dia e soluções sob medida para empresas. Para quem desenvolve software, há projetos de código aberto e ferramentas.",
  },
  doorsHeading: "Por onde você quer começar?",
  doors: [
    {
      id: "apps",
      title: "Apps",
      subtitle: "Para o seu dia a dia",
      description:
        "Treino, alimentação e carreira em tecnologia. O Gymtero já está disponível; o Nutrinima e o Jobxtech estão a caminho.",
      highlights: [
        "Gymtero na web e no Android",
        "Nutrinima e Jobxtech com lista de espera",
      ],
      cta: { label: "Ver os apps", href: "/apps" },
    },
    {
      id: "business",
      title: "Para sua empresa",
      subtitle: "Soluções sob medida",
      description:
        "Apps e sistemas sob medida, com consulta inicial gratuita, e o Codecious Distribute em acesso antecipado.",
      highlights: [
        "Consulta inicial gratuita",
        "Apps que funcionam sem download (PWA)",
      ],
      cta: { label: "Conhecer as soluções", href: "/business" },
    },
    {
      id: "developers",
      title: "Para desenvolvedores",
      subtitle: "Código aberto e ferramentas",
      description:
        "Projetos de código aberto e ferramentas: o framework PHP Bootgly, a biblioteca Dataruni para apps React e o Codecious Build, em preparação.",
      highlights: [
        "Bootgly: framework PHP sem dependências",
        "Dataruni (experimental)",
      ],
      cta: { label: "Ver os projetos", href: "/developers" },
    },
  ],
  about: {
    heading: "Sobre a Codecious",
    text: "A Codecious é uma empresa brasileira de tecnologia com sede em São Paulo. Desenvolvemos aplicativos web progressivos (PWAs), que funcionam em qualquer aparelho, e publicamos nas lojas quando o projeto pede.",
    appsLabel: "Apps próprios",
    stats: [{ value: "9+", label: "Clientes atendidos" }],
  },
  blog: {
    heading: "Blog",
    text: "Artigos sobre treino, alimentação e carreira em tecnologia.",
    cta: { label: "Ler o blog", href: "/blog/" },
  },
  contact: {
    heading: "Tem um projeto em mente?",
    text: "Conte para a gente. A consulta inicial é gratuita.",
    cta: { label: "Fale conosco", href: "/business#contato" },
  },
};
